import { FETCH_OPERATIONALSKILLSTREE, FETCH_TECHNICALSKILLSTREE, FETCH_DASHBOARD, DASHBOARD_ERROR,FETCH_DASHBOARD_LIST } from '../actions/types';

const INITIAL_STATE = { operationalSkillsTree: {}, message: '', error: '' };

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_OPERATIONALSKILLSTREE:
            return { ...state, operationalSkillsTree: action.payload.tree, message: '', error: '' };
        case FETCH_TECHNICALSKILLSTREE:
            return { ...state, technicalSkillsTree: action.payload.tree, message: '', error: '' };
        case FETCH_DASHBOARD:
            return { ...state, data: action.payload.documents, message: '', error: '' };
        case FETCH_DASHBOARD_LIST:
            return {...state, list: action.payload.list, message: '', error: '' }
        case DASHBOARD_ERROR:
            return { ...state, error: action.payload };
        default:
            return { ...state }
    }
}
